<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <CIcon
        class="d-block"
        name="logo_new"
        size="custom-size"
        :height="35"
        :viewBox="`0 0 ${minimize ? 110 : 556} 134`"
      />
    </CSidebarBrand>
    <CRenderFunction flat :content-to-render="nav"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import axios from 'axios'
export default {
  name: 'TheSidebar',
  data () {
    return {
      //minimize: false,
      nav: [],
      //show: true,
      buffor: [],
    }
  },
  computed: {
    show () {
      return this.$store.state.sidebarShow
    },
    minimize () {
      return this.$store.state.sidebarMinimize
    }
  },
  methods: {
    dropdown(data){
      let result = {
            _name: 'CSidebarNavDropdown',
            name: data['name'],
            route: data['href'],
            icon: data['icon'],
            _children: [],
      }
      for(let i=0; i<data['elements'].length; i++){
        if(data['elements'][i]['slug'] == 'dropdown'){
          result._children.push( this.dropdown(data['elements'][i]) );
        }else{
          result._children.push(
            {
                   _name:  'CSidebarNavItem',
                   name:   data['elements'][i]['name'],
                   to:     data['elements'][i]['href'],
                   icon:   data['elements'][i]['icon']
            }
          );
        }
      }
      return result;
    },
    rebuildData(data){
      this.buffor = [{
        _name: 'CSidebarNav',
        _children: []
      }];
      for(let k=0; k<data.length; k++){
        switch(data[k]['slug']){
          case 'link':
            if(data[k]['href'].indexOf('http') !== -1){
              this.buffor[0]._children.push(
                  {
                      _name: 'CSidebarNavItem',
                      name: data[k]['name'],
                      href: data[k]['href'],
                      icon: data[k]['icon'],
                      target: '_blank'
                  }
              );
            }else{
              this.buffor[0]._children.push(
                  {
                      _name: 'CSidebarNavItem',
                      name: data[k]['name'],
                      to:   data[k]['href'],
                      icon: data[k]['icon'],
                  }
              );
            }
          break;
          case 'title':
            this.buffor[0]._children.push(
              {
                _name: 'CSidebarNavTitle',
                _children: [data[k]['name']]
              }
            );
          break;
          case 'dropdown':
            this.buffor[0]._children.push( this.dropdown(data[k]) );
          break;
        }
      }
      return this.buffor;
    }
  },
  mounted () {
    this.$root.$on('toggle-sidebar', () => {
      const sidebarOpened = this.show === true || this.show === 'responsive'
      this.show = sidebarOpened ? false : 'responsive'
    })
    this.$root.$on('toggle-sidebar-mobile', () => {
      const sidebarClosed = this.show === 'responsive' || this.show === false
      this.show = sidebarClosed ? true : 'responsive'
    })
    let self = this;

    console.log(this.$apiAdress);

    let menuFireGods=[
      {
        "id": 1,
        "slug": "link",
        "name": "首頁",
        "href": "/IndexFireGods",
        "hasIcon": true,
        "icon": "cil-speedometer",
        "iconType": "coreui"
      },
      {
        "id": 50,
        "slug": "link",
        "name": "網頁內容設定",
        "href": "/ContentCatalogSimple",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 50,
        "slug": "link",
        "name": "灶君靈籤",
        "href": "/SignItemsList",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 50,
        "slug": "link",
        "name": "活動設定",
        "href": "/EventDefine",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },

      {
        "id": 50,
        "slug": "link",
        "name": "活動報名名單",
        "href": "/EventItemsList",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 50,
        "slug": "link",
        "name": "專題活動",
        "href": "/EventDefine2List",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 50,
        "slug": "link",
        "name": "點燈產品設定",
        "href": "/ProductDefine",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 50,
        "slug": "link",
        "name": "點燈訂單",
        "href": "/ProductOrderList",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 50,
        "slug": "link",
        "name": "文創產品設定",
        "href": "/ECProductList",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 50,
        "slug": "link",
        "name": "文創訂單",
        "href": "/ECOrderList",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 50,
        "slug": "link",
        "name": "會員管理",
        "href": "/ECMemberList",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 52,
        "slug": "link",
        "name": "設定",
        "href": "/Setting",
        "hasIcon": true,
        "icon": "cil-layers",
        "iconType": "coreui"
      },
      {
        "id": 52,
        "slug": "link",
        "name": "設定-頁面",
        "href": "/SettingPage",
        "hasIcon": true,
        "icon": "cil-layers",
        "iconType": "coreui"
      },
      {
        "id": 52,
        "slug": "link",
        "name": "設定-檔案管理",
        "href": "/SettingFileManager",
        "hasIcon": true,
        "icon": "cil-layers",
        "iconType": "coreui"
      },
      {
        "id": 52,
        "slug": "link",
        "name": "設定-帳號管理",
        "href": "/ECAccountList",
        "hasIcon": true,
        "icon": "cil-layers",
        "iconType": "coreui"
      },
      {
        "id": 52,
        "slug": "link",
        "name": "變更密碼",
        "href": "/ChangePwd",
        "hasIcon": true,
        "icon": "cil-layers",
        "iconType": "coreui"
      },
      {
        "id": 52,
        "slug": "link",
        "name": "登出",
        "href": "/login",
        "hasIcon": true,
        "icon": "cil-layers",
        "iconType": "coreui"
      }
    ];
    let menuFireGodsPowerUser=[
      {
        "id": 1,
        "slug": "link",
        "name": "首頁",
        "href": "/IndexFireGods",
        "hasIcon": true,
        "icon": "cil-speedometer",
        "iconType": "coreui"
      },
      {
        "id": 50,
        "slug": "link",
        "name": "文創產品設定",
        "href": "/ECProductList",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 50,
        "slug": "link",
        "name": "文創訂單",
        "href": "/ECOrderList",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 50,
        "slug": "link",
        "name": "會員管理",
        "href": "/ECMemberList",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 52,
        "slug": "link",
        "name": "變更密碼",
        "href": "/ChangePwd",
        "hasIcon": true,
        "icon": "cil-layers",
        "iconType": "coreui"
      },
      {
        "id": 52,
        "slug": "link",
        "name": "登出",
        "href": "/login",
        "hasIcon": true,
        "icon": "cil-layers",
        "iconType": "coreui"
      }
    ];

    if (process.env.VUE_APP_siteType==="fireGods"){
      let roles = localStorage.getItem("roles");
      if (roles==="admin,poweruser,user") {
        self.nav=self.rebuildData(menuFireGods);
      }else{
        self.nav=self.rebuildData(menuFireGodsPowerUser);
      }


    }


    // axios.get( this.$apiAdress + '/api/menu?token=' + localStorage.getItem("api_token") )
    // .then(function (response) {
    //   debugger // eslint-disable-line
    //   self.nav = self.rebuildData(response.data);
    // }).catch(function (error) {
    //   console.log(error);
    //   self.$router.push({ path: '/login' });
    // });
  }
}
</script>
